import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { ApiResponse } from 'src/app/all-modules/shared/common-model/common.model';
import { ApiUrlConstants } from 'src/app/all-modules/shared/constants/api_url_constants';
import { HttpRequestService } from 'src/app/all-modules/shared/services/http-request.service';
import { soClientSentFeedbackToTeamDTO } from '../model/client-feedback.model';
import { laborAvailabilityViewModel, laborConfirmationDTO, soClientFeedbackLinkDetails } from '../model/expose.model';
import { ReportLinkViewModel } from '../model/report-link.model';

@Injectable({
  providedIn: 'root'
})
export class ExposeService {
  constructor(private httpRequestService: HttpRequestService) { }

  soClientSendFeedbackToTeam(data: soClientSentFeedbackToTeamDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soClientSendFeedbackToTeam, data);
  }
  soGetClientFeedback(uniqId: any): Observable<soClientFeedbackLinkDetails> {
    return this.httpRequestService.getData<soClientFeedbackLinkDetails>(`${ApiUrlConstants.soGetClientFeedbackForClient}${uniqId}`);
  }
  verifyLaborAvailabilityLink(uniqId: any): Observable<laborAvailabilityViewModel> {
    return this.httpRequestService.getData<laborAvailabilityViewModel>(`${ApiUrlConstants.exposeVerifyLaborAvailability}${uniqId}`);
  }
  exposeConfirmLaborAvailability(data: laborConfirmationDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.exposeConfirmLaborAvailability, data);
  }
  // data = the app-relative path the short link opens, when the key is live.
  resolveShortLink(key: string): Observable<ApiResponse> {
    return this.httpRequestService.getData<ApiResponse>(`${ApiUrlConstants.exposeResolveShortLink}${encodeURIComponent(key)}`);
  }
  // DPP-143: public report page. The token is the grant — no login.
  getReportLink(token: string): Observable<ReportLinkViewModel> {
    return this.httpRequestService.getData<ReportLinkViewModel>(`${ApiUrlConstants.exposeGetReportLink}${encodeURIComponent(token)}`);
  }
  // A plain URL, opened by the browser itself: inline (PDF viewer) or as a download.
  reportDocumentUrl(token: string, emailDocumentId: string, download: boolean): string {
    return `${ApiUrlConstants.exposeReportLinkDownload}${encodeURIComponent(token)}/${encodeURIComponent(emailDocumentId)}?download=${download}`;
  }
}
